import Image from "next/image";
import Link from "next/link";

import { useTranslation } from "@flare/i18n";
import { Button, Heading, Text } from "@flare/ui/components";

import mainImg from "@/../public/next/images/not_found.png";

import { Footer } from "../components/footer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";

export default function UnsupportedCounty() {
  const { t } = useTranslation();

  return (
    <>
      <StepContainer className="flex items-center justify-start md:justify-center">
        <StepContent className="flex w-full max-w-[1440px] flex-col-reverse items-center justify-between gap-sp-5 md:flex-row">
          <div className="w-full md:w-1/2">
            <Heading
              variant="h3"
              textWrap="balance"
              className="hidden md:block"
            >
              {t("FUNNEL_UNSUPPORTED_COUNTY_TITLE")}
            </Heading>
            <Text className="mt-sp-3 text-center md:mt-sp-6 md:text-left">
              {t("FUNNEL_UNSUPPORTED_COUNTY_TEXT")}
            </Text>
            <Link href="/">
              <Button
                type="button"
                className="mt-sp-6 w-full md:mt-sp-8 md:w-fit"
              >
                {t("FUNNEL_UNSUPPORTED_COUNTY_BUTTON")}
              </Button>
            </Link>
          </div>
          <div className="w-full rounded-xl bg-marketing-2 md:w-1/2">
            <Image
              src={mainImg}
              alt={t("FUNNEL_UNSUPPORTED_COUNTY_IMAGE_ALT")}
              className="m-auto w-[70%]"
            />
          </div>
          <Heading
            variant="h3"
            alignment="center"
            className="py-sp-3 md:hidden"
          >
            {t("FUNNEL_UNSUPPORTED_COUNTY_TITLE")}
          </Heading>
        </StepContent>
      </StepContainer>
      <Footer />
    </>
  );
}
